export enum ProjectType {
    cloud = "cloud",
    npc = "npc",
    shared = "shared_folder",
}
